module.exports = __webpack_public_path__ + "static/media/HCMM826.2954eb98.jpg";